import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { TaskOverview } from '@apps/fiduciary/fiduciary.state';
import { LoadingService, provideLoadingService } from '@platform/shared/loading.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { TasksService } from '../tasks.service';
import { TaskTableComponent } from '../components/task-table/task-table.component';

@Component({
  selector: 'app-tasks-overview',
  templateUrl: './tasks-overview.component.html',
  styleUrls: ['./tasks-overview.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, TranslateModule, TaskTableComponent],
  providers: [provideLoadingService()],
})
export class TasksOverviewComponent implements OnInit {
  public myTasks$!: Observable<TaskOverview[]>;
  public searchForm: UntypedFormGroup;

  randomName1 = Math.random().toString();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: LoadingService,
    private tasksService: TasksService,
  ) {
    this.searchForm = this.formBuilder.group({
      search: [''],
    });
  }

  ngOnInit(): void {
    // former FiduciaryActions.loadAllCustomerSpacesFiduciaryTasksForUser
    this.myTasks$ = this.loadingService
      .showLoadingUntilCompleted(this.tasksService.getAllCustomerSpacesPortalTasks(['Open', 'InProgress']))
      .pipe(
        startWith([]),
        map((allTasksForUser) =>
          allTasksForUser.sort((a, b) => {
            if (!a.dueOn) {
              return 1;
            } else if (!b.dueOn) {
              return -1;
            } else if (b.dueOn < a.dueOn) {
              return 1;
            } else if (a.dueOn < b.dueOn) {
              return -1;
            }
            return 0;
          }),
        ),
      );
  }
}
